import axios, { AxiosResponse } from 'axios'
import { Get } from 'config/apiServiceConfig'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export interface ProductVendorAddVendorOptionType {
  id: number
  company_name: string
}

export interface ProductVendorAddPICOptionType {
  id: number
  name: string
  email: string
}

export interface ProductVendorAddPICSourcingOptionType {
  id: number
  full_name: string
  email: string
}

export interface ProductVendorAddLocationOptionType {
  location_id: number
  location_name: string
  location_type: string
}

export interface ProductVendorAddCatalogDetailType {
  preference: number
  rebate: number
  price: string
  vendor: { vendorId: number; vendorName: string }
  pic: { picId: number; picName: string; picEmail: string }
  picSourcing: { picId: number; picName: string; picEmail: string }
  locations: { locationId: number; locationName: string; locationType: string }[]
}

export interface ProductVendorAddPostPayloadType {
  preference: number
  vendorId: number
  picId: number
  picSourcingId: number
  price: number
  rebate: number
  locations: number[]
}

export interface ProductVendorAddPatchPayloadType {
  picId: number
  picSourcingId: number
  price: number
  rebate: number
  locations: number[]
}

export interface ProductCatalogLocationType {
  locationName: string
}

export interface ProductCatalogVendorType {
  vendorName: string
}

export interface ProductCatalogPICType {
  picName: string
}

export interface ProductCatalogItemType {
  catalogId: string | number
  preference: number
  vendor: ProductCatalogVendorType
  pic: ProductCatalogPICType
  price: string | number
  locations: ProductCatalogLocationType[]
  picSourcing: ProductCatalogPICType
}

export interface ProductCatalogPaginationType {
  pageSize: number
  pageIndex: number
  totalPages: number
  totalElements: number
  numberOfElements: number
}

// ==== PRODUCT VENDOR
export const getProductCatalogs = (
  id: string | number,
  params: Record<string, unknown>,
): Promise<
  AxiosResponse<{
    data: ProductCatalogItemType[]
    pagination: ProductCatalogPaginationType
  }>
> => axios.get(`${baseUrl}/api/product/${id}/catalogs`, { params })

export const patchPrimaryVendor = (
  productId: string | number,
  catalogId: string | number | null,
): Promise<AxiosResponse<{ message: string }>> =>
  axios.patch(`${baseUrl}/api/product/${productId}/catalog/${catalogId}/primary`)

export const deleteProductCatalog = (
  productId: string | number,
  catalogId: string | number,
): Promise<AxiosResponse<{ message: string }>> =>
  axios.delete(`${baseUrl}/api/product/${productId}/catalog/${catalogId}`)

// ==== PRODUCT VENDOR ADD
export const getVendor = (params: Record<string, unknown>): Promise<AxiosResponse> =>
  axios.get(`${baseUrl}/api/purchase-order/vendor`, { params })

export const getPIC = (params: {
  pageSize: number
}): Promise<AxiosResponse<{ data: ProductVendorAddPICOptionType[] }>> =>
  axiosInstanceApiGateway.Get<{ data: ProductVendorAddPICOptionType[] }, true>({
    url: '/commercial/internal/:version/vendors/contact/list',
    version: 'v1',
    params: { page_size: params.pageSize },
  })

export const getPICSourcing = (params: {
  pageSize: number
}): Promise<AxiosResponse<{ content: ProductVendorAddPICSourcingOptionType[] }>> =>
  axios.get(`${baseUrl}/api/product/catalog/pic`, { params })

export const getLocation = (params: {
  pageSize: number
  type: string
  name: string
}): Promise<AxiosResponse<{ content: ProductVendorAddLocationOptionType[] }>> =>
  axios.get(`${baseUrl}/api/location`, { params })

export const postProductCatalog = (
  id: string | number,
  payload: ProductVendorAddPostPayloadType,
): Promise<AxiosResponse<{ message: string }>> =>
  axios.post(`${baseUrl}/api/product/${id}/catalog`, payload)

// ==== PRODUCT VENDOR EDIT
export const getProductCatalogDetail = (
  productId: string,
  catalogId: string,
): Promise<AxiosResponse<{ data: ProductVendorAddCatalogDetailType }>> =>
  axios.get(`${baseUrl}/api/product/${productId}/catalog/${catalogId}`)

export const patchProductCatalog = (
  productId: string | number,
  catalogId: string | number,
  data: ProductVendorAddPatchPayloadType,
): Promise<AxiosResponse<{ message: string }>> =>
  axios.patch(`${baseUrl}/api/product/${productId}/catalog/${catalogId}`, data)
